"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _endpoints = require("../endpoints");
var _promiseCache = _interopRequireDefault(require("../utils/promise-cache"));
var _fetchWithAuth = _interopRequireDefault(require("../utils/fetch-with-auth"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function KameService(authState) {
  const fetch = new _fetchWithAuth.default(authState);
  const cache = new _promiseCache.default(authState);
  async function listPrograms() {
    return await cache('listPrograms', async () => {
      const res = await fetch(`${_endpoints.kameURL}/graphql`, {
        method: 'POST',
        headers: {
          'content-type': 'application/json'
        },
        body: JSON.stringify({
          query: `
                            query programsQuery {
                                programs {
                                    id
                                    name
                                }
                            }
                        `,
          variables: {}
        })
      });
      const {
        data,
        errors
      } = await res.json();
      if (errors) {
        throw new Error(errors.join('\n'));
      }
      return data.programs.sort((a, b) => a.name.localeCompare(b.name, undefined, {
        'sensitivity': 'base'
      }));
    })();
  }
  async function getProgram(programId) {
    return await cache(`getProgram:${programId}`, async () => {
      const res = await fetch(`${_endpoints.kameURL}/graphql`, {
        method: 'POST',
        headers: {
          'content-type': 'application/json'
        },
        body: JSON.stringify({
          query: `
                            query {
                                programById(id: "${programId}"){
                                    id
                                    name
                                }
                            }
                        `,
          variables: {}
        })
      });
      const {
        data,
        errors
      } = await res.json();
      if (errors) {
        throw new Error(errors.join('\n'));
      }
      return data.programById;
    })();
  }
  return {
    listPrograms,
    getProgram
  };
}
var _default = exports.default = KameService;
//# sourceMappingURL=kame.js.map